const isEditorPlugin = (pluginOrConfig) => {
  return "tiptapExtensions" in pluginOrConfig;
};
const isEditorPluginOptions = (pluginOrConfig) => {
  return !("tiptapExtensions" in pluginOrConfig);
};
export {
  isEditorPlugin,
  isEditorPluginOptions
};
//# sourceMappingURL=is-editor-plugin.js.map
